module.exports = __webpack_public_path__ + "media/applicants/usatoday-e89796d8.jpg";